export default `const float FLOAT_COMPARISON_EPSILON = 0.0001; 
const int MAX_ALLOWED_CATEGORICAL_VALUES = 7; 

in vec4 v_component_coords;

uniform vec2 u_wrap_dimensions;

uniform vec2 u_filtered_value_range;

uniform float u_allowed_categorical_values[MAX_ALLOWED_CATEGORICAL_VALUES];
uniform int u_num_categorical_values_stored;

uniform sampler2D u_color_scale;

uniform vec2 u_color_scale_range;

uniform vec4 u_non_selected_color;

uniform sampler2D u_cdf_tex;

uniform vec4 u_cdf_tex_rect;

uniform vec4 u_clip_rect;

float euclidean_modulo(float n, float m) {
    return m <= 0.0 ? n : mod(mod(n, m) + m, m);
}

/**
 * Determines if a value is within the selected range based on filtering mode
 * @param value             The value to check
 * @return                  True if the value should be displayed, false otherwise
 */
bool isValueInSelectedRange(float value) {
    if (u_num_categorical_values_stored > 0) {
        
        for (int i = 0; i < u_num_categorical_values_stored; i++) {
            if (abs(value - u_allowed_categorical_values[i]) < FLOAT_COMPARISON_EPSILON) {
                return true;
            }
        }
        return false;
    } else if (u_num_categorical_values_stored == 0) {
        
        return false;
    } else {
        
        bool allow_all_values = u_filtered_value_range[1] < u_filtered_value_range[0];
        bool allow_no_values = u_color_scale_range[1] < u_color_scale_range[0];
        return allow_all_values ||
               (!allow_no_values && value >= u_filtered_value_range[0] && value <= u_filtered_value_range[1]);
    }
}

void main() {
    
    if (v_component_coords.x < u_clip_rect.x) discard;
    if (v_component_coords.y < u_clip_rect.y) discard;
    if (v_component_coords.x > u_clip_rect.z) discard;
    if (v_component_coords.y > u_clip_rect.w) discard;

    vec2 coords = v_component_coords.xy - u_cdf_tex_rect.xy;
    coords.x = euclidean_modulo(coords.x, u_wrap_dimensions.x);
    coords.y = euclidean_modulo(coords.y, u_wrap_dimensions.y);
    vec2 uv = coords.xy / (u_cdf_tex_rect.zw - u_cdf_tex_rect.xy);

    
    if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
        discard;
    }

    
    float value = texture(u_cdf_tex, uv).r;
    if (isnan(value)) {
        discard;
    }

    bool value_in_selected_range = isValueInSelectedRange(value);

    
    float value_acceptability = value_in_selected_range ? 1.0 : 0.0;

    
    float color_in_value_range = saturate((value - u_color_scale_range[0]) / (u_color_scale_range[1] - u_color_scale_range[0]));
    vec3 selected_color = texture2D(u_color_scale, vec2(color_in_value_range, 0.0)).rgb;
    vec3 non_selected_color = vec3(u_non_selected_color.rgb + vec3(0.25, 0.25, 0.25)) * (0.25 + color_in_value_range);
    vec3 color = mix(non_selected_color, selected_color, value_acceptability);
    gl_FragColor = vec4(color, u_non_selected_color.a);
}`